/*=========================================================================================
  File Name: actions.js
  Namespace: collections
  Description: Vuex Store - Collection actions
==========================================================================================*/

import {
  createCollection,
  editCollection,
  getCollection,
  getUploadedCollectionsCsv,
  importCollectionCsv,
  listCollections,
  uploadCollectionCsv,
  validateCollectionCsv,
} from '@/services/collections.service'

import { adaptCollectionToStore } from '@/services/adapters/collectionAdapter.js'
import { listFiles } from '@/services/files.services.js'
import { listRelatedContent } from '@/services/related.service.js'

const actions = {
  async getCollectionAction({ commit }, { collectionId }) {
    const response = await getCollection({
      collectionId,
    })
    if (response) {
      commit('STORE_CURRENT_COLLECTION', response)
    }
    return response
  },
  async getAllCollections({ commit, rootState }, params = {}) {
    params.company = rootState.app.company
    const response = await listCollections(params)
    if (response) {
      commit('STORE_LIST_COLLECTIONS', response)
    }
    return response
  },
  async getUploadedCollectionsCsvAction({ commit }) {
    const response = await getUploadedCollectionsCsv()
    if (response.results) {
      commit('STORE_LIST_COLLECTIONS_CSV', response.results)
    }
    return response
  },
  async uploadCollectionCsvAction({ rootGetters }, formData) {
    const response = await uploadCollectionCsv({
      source: formData,
    })
    return response
  },
  async validateCollectionCsvAction({ rootGetters }, csvId) {
    const response = await validateCollectionCsv({
      csvId,
    })
    return response
  },
  async importCollectionCsvAction({ rootGetters }, csvId) {
    const response = await importCollectionCsv({
      csvId,
    })
    return response
  },
  async saveCollectionToApi({ commit, rootState, getters }) {
    let response
    if (getters.getCurrentCollection.id) {
      response = await editCollection({
        ...getters.getCurrentCollection,
        company: rootState.app.company,
        collectionId: getters.getCurrentCollection.id,
      })
    } else {
      response = await createCollection({
        ...getters.getCurrentCollection,
        company: rootState.app.company,
      })
    }
    commit('STORE_CURRENT_COLLECTION', response)
    return response
  },
  saveCollectionToStore({ commit }, payload) {
    commit('STORE_CURRENT_COLLECTION', payload)
  },
  saveCollectionToEdit({ commit }, collection) {
    commit(
      'STORE_CURRENT_COLLECTION',
      adaptCollectionToStore({
        data: collection,
      })
    )
  },
  addLeafToContentStructure({ commit }, leaf) {
    commit('ADD_LEAF_TO_STRUCTURE', leaf)
  },
  addLeafsBetweenContentStructure({ commit }, payload) {
    commit('ADD_LEAFS_INTO_STRUCTURE', payload)
  },
  removeLeafToContentStructure({ commit }, leaf) {
    commit('REMOVE_LEAF_TO_STRUCTURE', leaf)
  },
  resetCurrentCollection({ commit }) {
    commit('RESET_CURRENT_COLLECTION')
  },
  renameGroupOfContentStructure({ commit }, nameObject) {
    commit('RENAME_GROUP', nameObject)
  },
  addGroupToContentStructure({ commit }, newGroup) {
    commit('ADD_GROUP_TO_STRUCTURE', newGroup)
  },
  removeGroupToContentStructure({ commit }, group) {
    commit('REMOVE_GROUP_OF_STRUCTURE', group)
  },
  updateContentStructure({ commit }, contentToOrder) {
    commit('UPDATE_CONTENT_ORDER', contentToOrder)
  },
  deleteContentStructure({ commit }) {
    commit('RESET_CURRENT_COLLECTION_CONTENT')
  },
  async getAllCollectionFiles({ commit }, files) {
    const response = await listFiles({
      ids: files,
    })
    commit('STORE_CURRENT_COLLECTION_FILES', response.results)
  },

  async searchCollections({ rootState }, params = {}) {
    params.company = rootState.app.company
    const response = await listCollections(params)
    return response
  },
  async searchRelatedContent(context, params = {}) {
    const response = await listRelatedContent(params)
    return response
  },
}

export default actions
